export const VERSION_APP = "0.7.0.beta"
